export const pushEvent = (event, params = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
};

export const trackPhoneClick = (href, location) =>
  pushEvent('phone_click', {
    phone_number: href.replace('tel:', '').replace(/[^\d+]/g, ''),
    click_location: location || window.location.pathname,
  });

export const initPhoneClickTracking = () => {
  const handler = (e) => {
    const link = e.target.closest && e.target.closest('a[href^="tel:"]');
    if (link) trackPhoneClick(link.getAttribute('href'));
  };
  document.addEventListener('click', handler, true);
  return () => document.removeEventListener('click', handler, true);
};
